export default "__VITE_ASSET__PL7FxZxl__"